<script setup lang="ts">
interface Props {
  modelValue: string
  label?: string
  placeholder?: string
  type?: string
  error?: string
  disabled?: boolean
  rules?: ((v: string) => true | string)[]
}

interface Emits {
  (e: 'update:modelValue', value: string): void
}

withDefaults(defineProps<Props>(), {
  label: '',
  placeholder: '',
  type: 'text',
  error: '',
  disabled: false,
  rules: () => [],
})

defineEmits<Emits>()
</script>

<template>
  <v-text-field
    :model-value="modelValue"
    :label="label"
    :placeholder="placeholder"
    :type="type"
    :error-messages="error ? [error] : []"
    :disabled="disabled"
    :rules="rules"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<style scoped lang="scss">
</style>
